import React from "react";
import { Text } from "@sitecore-jss/sitecore-jss-react";

import AuthImage from "@/react-components/AuthImage";
import { fontSizeEnum, positionEnum } from "@/utils/enum";

const ImageSection = (props) => {
  const fields = props?.fields;
  const imgSrc = props?.fields?.image?.value?.src;

  // 画像タイトルフォントスタイル
  const titleFontSize = (() => {
    switch (fields?.titleFontSize?.value?.toLowerCase()) {
      case fontSizeEnum.middle:
        return "title-font-size-middle";
      case fontSizeEnum.small:
        return "title-font-size-small";
      default:
        return "title-font-size-big";
    }
  })();
  // 補足説明フォントスタイル
  const descFontSize = (() => {
    switch (fields?.descFontSize?.value?.toLowerCase()) {
      case fontSizeEnum.middle:
        return "desc-font-size-middle";
      case fontSizeEnum.small:
        return "desc-font-size-small";
      default:
        return "desc-font-size-big";
    }
  })();
  // 位置
  const position = (() => {
    switch (fields?.position?.value?.toLowerCase()) {
      case positionEnum.center:
        return "center";
      case positionEnum.right:
        return "right";
      default:
        return "left";
    }
  })();
  // 該当画像表示エリアは、レポートエリアの幅の表示比率を設定する
  const ratio = `${(fields?.ratio?.value || 0.5) * 100}%`;
  return (
    <div className={`image-section-container ${position}`}>
      <div
        style={{
          width: ratio,
        }}
      >
        <Text
          field={fields?.Imgtitle}
          tag="div"
          className={`title ${titleFontSize}`}
        />
        {imgSrc && <AuthImage src={imgSrc} className="image" />}
        <Text
          field={fields?.desc}
          tag="div"
          className={`desc ${descFontSize}`}
        />
      </div>
    </div>
  );
};

export default ImageSection;
